import { IWidgetConfiguration, WidgetBase } from '../models';
import { Helper } from '../../common';

import { buttonWidgetDefinition as definition } from './button.definition';

export enum ButtonAction {
    Redirect
}

export interface ButtonWidgetConfiguration extends IWidgetConfiguration {
    hasIcon: boolean;
    hasLabel: boolean;
    label: string;
    action: ButtonAction;
    destination: string;
}

export class ButtonWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: ButtonWidgetConfiguration;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 1;
    sizeY = 6;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = {
            hasIcon: true,
            label: 'My button',
            hasLabel: true,
            action: ButtonAction.Redirect,
            destination: ''
        };
    }
}